module.exports = __webpack_public_path__ + "img/tyler-union-logo.946a03e8.jpg";